// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"2e3cd511","872":"e6df8ee2"}[chunkId] + ".chunk.js";
};